import { EyeOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import { ColumnType } from 'antd/es/table'
import PreviewShipmentBlank from '../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import resolveUploadUrl from '../../../helpers/resolve-upload-url'
import Task from '../../../types/api/task'
import CorrectorTaskActions from '../components/corrector-task-actions'

const formatMeterage = (task: Task): string => {
    const length = task.shipment?.calculated?.materialLength
    if (length == null || Number.isNaN(Number(length))) return '—'
    return `${Number(length).toLocaleString('ru-RU')} м`
}

const formatCopies = (task: Task): string => {
    const positions = task.shipment?.shipment_positions
    if (!positions?.length) return '—'
    const total = positions.reduce((sum, p) => sum + (Number(p.copies) || 0), 0)
    return total.toLocaleString('ru-RU')
}

export const getCorrectorTasksColumns = (options?: {
    showActions?: boolean
}): ColumnType<Task>[] => {
    const columns: ColumnType<Task>[] = [
        {
            title: 'Клиент',
            key: 'client',
            render: (_v, record) => record.shipment?.client?.name || '—',
        },
        {
            title: 'Номер отгрузки',
            key: 'shipmentId',
            width: 110,
            render: (_v, record) => record.shipment?.id ?? '—',
        },
        {
            title: 'Штамп',
            key: 'stamp',
            width: 100,
            render: (_v, record) => record.shipment?.stamp?.number ?? '—',
        },
        {
            title: 'Метраж',
            key: 'meterage',
            width: 110,
            render: (_v, record) => formatMeterage(record),
        },
        {
            title: 'Тираж',
            key: 'copies',
            width: 100,
            render: (_v, record) => formatCopies(record),
        },
        {
            title: 'Форм',
            key: 'forms',
            width: 80,
            render: (_v, record) =>
                record.shipment?.form_set?.forms?.length ??
                record.shipment?.numberOfForms ??
                '—',
        },
        {
            title: 'Срок поставки',
            key: 'clientDeliveryDate',
            width: 120,
            render: (_v, record) => record.shipment?.clientDeliveryDate || '—',
        },
        {
            title: 'Производственный бланк',
            key: 'blank',
            width: 160,
            render: (_v, record) => {
                if (!record.shipment) return '—'
                return (
                    <PreviewShipmentBlank
                        blankType='production'
                        shipment={record.shipment}
                        blankPreviewFiles={record.shipment.blankPreviewFiles}
                    >
                        <Button size='small' icon={<EyeOutlined />}>
                            Просмотр
                        </Button>
                    </PreviewShipmentBlank>
                )
            },
        },
        {
            title: 'Файл сборки',
            key: 'assembleFile',
            width: 140,
            render: (_v, record) => {
                const files = record.shipment?.form_set?.assembleFile
                if (!files?.length) return '—'
                return (
                    <Space direction='vertical' size={0}>
                        {files.map(file => (
                            <a
                                key={file.documentId || file.id}
                                href={resolveUploadUrl(file.url)}
                                target='_blank'
                                rel='noreferrer'
                            >
                                {file.name || 'Скачать'}
                            </a>
                        ))}
                    </Space>
                )
            },
        },
    ]

    if (options?.showActions !== false) {
        columns.push({
            title: 'Действия',
            key: 'actions',
            width: 260,
            render: (_v, record) => <CorrectorTaskActions task={record} />,
        })
    }

    return columns
}
